import Header from './components/Header';
import Hero from './components/Hero';
import Feed from './components/Feed';
import Moments from './components/Moments';
import Ranking from './components/Ranking';
import Talk from './components/Talk';
import About from './components/About';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <Feed />
        <Moments />
        <Ranking />
        <Talk />
        <About />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}